/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_EnterpriseInputs */

const en_landing_pricing_enterprise = /** @type {(inputs: Landing_Pricing_EnterpriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise`)
};

const zh_landing_pricing_enterprise = /** @type {(inputs: Landing_Pricing_EnterpriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`企业版`)
};

/**
* | output |
* | --- |
* | "Enterprise" |
*
* @param {Landing_Pricing_EnterpriseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_enterprise = /** @type {((inputs?: Landing_Pricing_EnterpriseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_EnterpriseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_enterprise(inputs)
	return zh_landing_pricing_enterprise(inputs)
});
export { landing_pricing_enterprise as "landing.pricing.enterprise" }